import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useEffect, useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { FormatMoney } from '../../formatMoney'
import { useDispatch } from 'react-redux'

import { Container, BarData, BarContainer, Bar } from './style'

export function BarGraphics({ 
    datasForGraphic, 
    isExportButtonVisible,
    isButtonFilterVisible = false
}) {
    const [datas, setDatas] = useState([])
    const { setListBusinessToFilter } = useAdministrativeContext()

    const dispatch = useDispatch()

    useEffect(() => {
        const valueFirstBusiness = datasForGraphic[0]?.value

        const editList = datasForGraphic.map(elem => {
            return {
                ...elem,
                percent: Math.round((100 * elem.value) / valueFirstBusiness)
            }
        })

        setDatas(editList)
    }, [datasForGraphic])


    function handleChooseBusinessToFilterDashboard(id) {
        setListBusinessToFilter([id])
        dispatch({type: '', title: 'Ranking' })
    } 

   
    return(
        <Container>
            {datas.map((data, index) => (
                <BarData 
                    key={index}
                    name={data.name}
                    isExportButtonVisible={isExportButtonVisible}
                >

                    <div className='info'>
                        <strong>
                            {data.name}
                        </strong>
                       
                        {data.subname && <span title={data.subname}>{data.subname}</span>}
                    </div>

                    <BarContainer>
                        <Bar percent={data.percent}>
                            {data.percent >= 70 ?
                                <FormatMoney value={data.value}/>
                                : 
                                <></>
                            }
                        </Bar>

                        {data.percent < 70 ?
                            <FormatMoney value={data.value}/>
                            : 
                            <></>
                        }
                    </BarContainer>
                    
                    {data.perc !== undefined && <p className='perc'>{data?.perc}%</p>}
                    
                    {
                        isButtonFilterVisible &&
                        <FaFilter 
                            onClick={() => handleChooseBusinessToFilterDashboard(data.id)}
                        />
                    }


                </BarData>
            ))}
        </Container>
    )
}
